<template>
  <div class="e2e-gfx3d-submit">
    <button class="btn btn-primary" @click="onSubmit">{{fragment.text}}</button>
  </div>
</template> 

<script> 
import { submitData } from "./gfx3d.js";

export default { 
  name: "fragment-gfx3d-submit",
  props: ["fragment"],
  methods: {
    onSubmit() {
      submitData();
    }
  }
};
</script>
  

<style scoped>
</style> 